import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from 'axios'
import Vconsole from "vconsole";
Vue.prototype.$http = axios
Vue.config.productionTip = false;
// Vue.prototype.$vConsole = new Vconsole();

// 引入自定义Toast组件
import './assets/css/Toast.scss';
import Toast from './utils/Toast';
Vue.use(Toast);

// 引入VantUI库组件
import { Picker, Popup, NoticeBar } from 'vant';
Vue.use(Picker)
Vue.use(Popup)
Vue.use(NoticeBar)

// 正式链接// 错误 Vue.prototype.$pageUrl = 'https://hzwx.ciccv.cn/html/ccb_healthModelRoom/index.html';
// Vue.prototype.$pageUrl = 'https://hzwx.ciccv.cn/html/ccb_healthModel/index.html';
Vue.prototype.$AppId = 'wx4f4a5ec5e2437cb2';//正式appid
Vue.prototype.$pageUrl = 'https://hzwx.ciccv.cn/html/ccb_health_ybj/index.html';//缓存
// 测试链接
// Vue.prototype.$AppId = 'wx6f3ce603f3ea7c34';//测试appid
// Vue.prototype.$pageUrl = 'https://testxf.ciccv.cn/html/ccb_healthModelRoomwl/index.html';
// Vue.prototype.$pageUrl = 'https://170ts.mobi88.cn/wl001/sz/sz_ybj/index.html';


// npm run dev // 开发环境

// npm run test // 测试环境

// npm run build // 正式环境打包

// npm run build:test // 测试环境打包

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
